import { ref } from 'vue'
import type { AiSkillDefinition } from '@/types'
import type { AiConversationInfo, AiMessageInfo } from './types'

export const conversations = ref<AiConversationInfo[]>([])
export const currentMessages = ref<AiMessageInfo[]>([])
// Pagination de l'historique : `hasMoreConversations` indique s'il reste des
// pages côté Supabase, `loadingMoreConversations` évite les requêtes
// concurrentes pendant le scroll.
export const hasMoreConversations = ref(true)
export const loadingMoreConversations = ref(false)

export const userSkillDefinitions = ref<AiSkillDefinition[]>([])
export const hydrated = ref(false)
export const hydrating = ref(false)
